<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import newsBg from "@/assets/images/bg/news-bg.png";
import PageHead from "@/components/PageHead/PageHead.vue";
import axios from "axios";
import { useStore } from "vuex";
import Width from "@/pages/Index/Width.vue";
import dayjs from "dayjs";

const store = useStore()
const route = useRoute()

const details = ref(null)

const currentLang = computed(() => {
	
	const lang = store.getters.currentLanguage
	
	return lang === 'cn' ? 'zh' : lang
	
})

const getNewsDetail = async () => {
	const res = await axios.get("/api/api/new/" + route.params.id)
		.catch(err => {
			throw new Error(err.message)
		})
	console.log('res --------->', res)
	details.value = res.data[0][0]
}

const newsDetailsFormat = (originalHtml) => {
	const imgSrcRegex = /<img[^>]*src=['"]([^'"]+?)['"][^>]*>/gi;
	
	// 首先处理src路径
	let processedHtml = originalHtml
	
	// 使用正则表达式匹配style属性中的width并替换为100%
	const widthRegex = /style\s*=\s*['"]([^'"]*)['"]/gi;
	processedHtml = processedHtml?.replace(widthRegex, (match, styleAttrContent) => {
		// 使用另一个正则表达式在style属性的内容里查找并替换width
		const widthInStyleRegex = /width\s*:\s*[^;]+;\s*/gi;
		const newStyleContent = styleAttrContent.replace(widthInStyleRegex, 'width: 100%; ');
		// 确保其他样式保留，并在没有width时也能正确处理
		return `style="${newStyleContent.trim()}"`;
	});
	
	// 添加默认的max-width和height样式给没有style属性的img标签
	processedHtml = processedHtml?.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
	
	return processedHtml;
}

onMounted(() => {
	getNewsDetail()
})
</script>

<template>
	<div class="detail">
		<PageHead
			:title="$t('content.News')"
			:bg-image="newsBg"
		/>
		
		<Width>
			<div class="detail__content">
				<div class="detail__content__title">
					{{ details?.[`title${currentLang}`] || details?.titlezh }}
				</div>
				<div class="detail__content__date">
					{{ $t('news.createTime') }}{{ dayjs(details?.time).format('YYYY-MM-DD') }}
				</div>
				<div
					class="detail__content__content"
					v-html="newsDetailsFormat(details?.[`content${currentLang}`] || details?.contentzh)"
				/>
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
.detail {
	background-color: #F5F5F5;
	&__content {
		padding: 70px 0;
		
		&__title {
			text-align: center;
			font-size: 32px;
			font-weight: bold;
			line-height: 40px;
			word-wrap: break-word;
			word-break: break-word;
		}
		
		&__date {
			margin-top: 20px;
			text-align: center;
			font-size: 16px;
		}
		
		&__content {
			margin-top: 30px;
			p {
				font-size: 18px;
				line-height: 36px;
				color: #3D3D3D;
			}
		}
		
	}
	
}

@media screen  and (max-width: 768px ) {
	.detail {
		
		&__content {
			padding: 30px 0;
			
			&__title {
				font-size: 16px;
			}
			
			&__date {
				font-size: 14px;
				margin-top: 20px;
			}
			
			&__content {
				margin-top: 20px;
				
				p {
					font-size: 16px;
					line-height: 30px;
				}
			}
		}
	}
}

@media screen  and (min-width: 800px ) {
	.detail__content__content{
		width: 60%;
		margin: auto;
	}
}
</style>